<ng-container *ngIf="!isQqc; else checkbox">
  <ng-container *ngIf="pmiOption$ | async">
    <nibtravel-option
      [title]="'Private Medical Insurance'"
      [currencyCode]="currencyCode$ | async"
      [leadText]="leadText"
      ><ng-template [ngTemplateOutlet]="checkbox"></ng-template>
    </nibtravel-option>
  </ng-container>
</ng-container>
<ng-template #checkbox>
  <div>
    <span class="label-heading"> Private Medical Insurance^ </span>
    <nibtravel-checkbox
      [e2eId]="e2eId.PmiOption"
      [hostId]="'pmi-host'"
      [inputId]="'pmi-input'"
      [inputName]="'pmi'"
      [label]="'Yes, all travellers have private medical cover.'"
      [labelId]="'pmi-label'"
      [checked]="checked$ | async"
      [required]="false"
      (valueChange)="onValueChange($event)"
    ></nibtravel-checkbox>
  </div>
</ng-template>
